import { Tabs } from "antd";
import "./style.css";
import { DayGraph } from "./graphs/DayGraphs/DayGraph";
import { MonthGraph } from "./graphs/MonthGraphs/MonthGraph";

export const dateFormat = "YYYY-MM-DD";
export const dateFormatByMonth = "YYYY-MM";

const items = [
	{
		key: "1",
		label: "日图",
		children: <DayGraph />,
	},
	{
		key: "2",
		label: "月图",
		children: <MonthGraph />,
	},
];

function DashboardPage() {
	const handleChange = (key) => {
		localStorage.setItem("graphTabKey", key);
	};

	const selectedKey = localStorage.getItem("graphTabKey") ?? 1;

	return (
		<Tabs
			defaultActiveKey={selectedKey}
			items={items}
			onChange={handleChange}
		/>
	);
}

export default DashboardPage;
